import { render, staticRenderFns } from "./RsH2.vue?vue&type=template&id=36653a86&scoped=true"
import script from "./RsH2.vue?vue&type=script&lang=js"
export * from "./RsH2.vue?vue&type=script&lang=js"
import style0 from "./RsH2.vue?vue&type=style&index=0&id=36653a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36653a86",
  null
  
)

export default component.exports